import { Link } from "react-router-dom";

export default function TourCard(props) {
  const { tour } = props;

  return (
    <Link
      to={`/tak-tour/${tour.id}`}
      className="card round border-success m-1 item d-block"
      style={{ height: "350px", direction: "rtl" }}
      key={tour.id + Math.random() * 50}
    >
      <div className="position-relative" style={{ height: "55%" }}>
        <img
          src={tour.image}
          alt=""
          className="card-img-top round border tour-border-color h-100"
          style={{ objectFit: "fill" }}
        />
        <div className="position-absolute rounded tourLabel1 size3">
          {tour.city}
        </div>
        <div className="position-absolute rounded tourLabel2 size2  digits fw-bold">
          زمان: {tour.start_time}
        </div>
      </div>
      <div className="card-body size5 d-flex flex-column justify-content-around">
        <div className="d-flex justify-content-center">
          <h6 style={{ fontWeight: "bolds" }}>{tour.title}</h6>
        </div>
        <div className="row ">
          <div className="way-color col-6 font-regular">تاریخ برگشت:</div>
          <div className="col-6  fw-bold digits">{tour.end_time}</div>
        </div>

        <div className="row ">
          <div className="way-color col-6 font-regular">ظرفیت:</div>
          <div className="col-6 digits fw-bold ">
            {tour.max_participant > 0
              ? `${tour.max_participant} نفر`
              : "تکمیل شده"}
          </div>
        </div>

        <div className="row ">
          <div className="way-color col-6 font-regular">اقلام مورد نیاز:</div>
          <div className="col-6 digits essential-accessories">
            {tour.essentials}
          </div>
        </div>

        <div className="row ">
          <div className="way-color col-6 font-regular">قیمت:</div>
          <div
            className="col-6 digits fw-bold  price"
            style={{
              fontSize:
                tour.price.toString().length < 6
                  ? 15
                  : (15 * 12) / (tour.price.toString().length + 6),
            }}
          >
            {tour.price} تومان
          </div>
        </div>
      </div>
    </Link>
  );
}
